import script from "./BaseTooltipCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTooltipCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseTooltipCard.vue?vue&type=style&index=0&id=8cf2a1b2&lang=scss"

const __exports__ = script;

export default __exports__